import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import Select from 'react-select'
import { useForm } from 'react-hook-form'
import { Table, Button } from 'react-bootstrap'
import axios from 'axios'
import Papa from 'papaparse'
import ConfirmModal from '../ui/ConfirmModal'

function ActImport() {
  const [testRecords, setTestRecords] = useState([])
  const { id } = useParams()

  const initData = (id) => {
    if (id) {
      getTestRecords()
    }
  }

  const getTestRecords = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}getActscale?test_id=${id}`,
      {
        headers: {
          token:
            typeof windows !== 'undefined' ? localStorage.getItem('token') : '',
        },
      }
    )
    if (response.status === 200) {
      setTestRecords(response.data.data)
    }
  }

  useEffect(() => {
    initData(id)
  }, [id])

  const [csvData, setCsvData] = useState([])
  const [importModalOpen, setImportModalOpen] = useState(false)
  const [importModalMessage, setImportModalMessage] = useState('')

  const handleFileUpload = (event) => {
    const file = event.target.files[0]

    Papa.parse(file, {
      header: false, // No headers in this CSV format
      complete: handleParsedData,
    })
  }

  const handleParsedData = (parsedData) => {
    setCsvData(parsedData.data)
  }

  const saveToMongoDB = () => {
    fetch(`${process.env.REACT_APP_BASE_URL}saveactscale`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        testId: id,
        csvData: csvData,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response.text()
        } else {
          throw new Error('Failed to save data')
        }
      })
      .then((message) => {
        setImportModalMessage('Data saved successfully')
        setImportModalOpen(true)
      })
      .catch((error) => {
        setImportModalMessage('An error occurred while saving data')
        setImportModalOpen(true)
      })
  }

  return (
    <div className="w-full mt-2.5 max-md:max-w-full">
      {/* Header */}
      <div className="flex justify-between items-center border border-[#F0F0F0] bg-white px-5 py-4 rounded-t-[10px]">
        <h2 className="text-lg font-bold text-[#030303]">Upload Scale</h2>
        <Link
          className="bg-[#DE3C7D] text-white px-4 py-2 rounded-md hover:bg-[#c72c6a] transition-colors font-medium"
          to="/tests"
        >
          Back to Act Tests
        </Link>
      </div>
      {/* CSV Import Section */}
      <div className="flex items-center gap-4 bg-white border-x border-[#F0F0F0] px-5 py-4">
        <input
          type="file"
          accept=".csv"
          onChange={handleFileUpload}
          className="block w-60 text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-[#EFEFEF] file:text-[#DE3C7D] hover:file:bg-[#DE3C7D] hover:file:text-white"
        />
        <button
          className="bg-[#EFEFEF] text-[#DE3C7D] px-4 py-2 rounded-md border border-[#DE3C7D] font-medium hover:bg-[#DE3C7D] hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={saveToMongoDB}
          disabled={!csvData || !Array.isArray(csvData) || csvData.length === 0}
        >
          Import Questions
        </button>
      </div>
      {/* Scale Table Section */}
      <div className="bg-white border-x border-b border-[#F0F0F0] rounded-b-[10px] p-6 mt-2 overflow-x-auto">
        <table
          border="1"
          cellPadding="10"
          cellSpacing="10"
          width="100%"
          className="scale_table"
        >
          <thead>
            <tr height="40px">
              <td rowSpan="2" className="text-center">
                <strong>
                  Scale
                  <br />
                  Scores
                </strong>
              </td>
              <td colSpan="4" className="text-center">
                <strong>Raw Scores</strong>
              </td>
              <td rowSpan="2" className="text-center">
                <strong>
                  Scale
                  <br />
                  Scores
                </strong>
              </td>
            </tr>
            <tr>
              <td className="text-center">
                <strong>Test 1</strong> <br />
                English
              </td>
              <td className="text-center">
                <strong>Test 2</strong> <br />
                Mathematics
              </td>
              <td className="text-center">
                <strong>Test 3</strong>
                <br />
                Reading
              </td>
              <td className="text-center">
                <strong>Test 4</strong>
                <br />
                Science
              </td>
            </tr>
          </thead>
          <tbody>
            {testRecords.map((item, index) => (
              <tr key={index}>
                <td className="text-center">
                  <strong>{item.scale_score}</strong>
                </td>
                <td className="text-center">
                  {item.eglish_minscore === null &&
                  item.eglish_maxscore === null
                    ? '-'
                    : item.eglish_minscore === item.eglish_maxscore
                    ? item.eglish_minscore
                    : `${item.eglish_minscore}-${item.eglish_maxscore}`}
                </td>
                <td className="text-center">
                  {item.math_minscore === null && item.math_maxscore === null
                    ? '-'
                    : item.math_minscore === item.math_maxscore
                    ? item.math_minscore
                    : `${item.math_minscore}-${item.math_maxscore}`}
                </td>
                <td className="text-center">
                  {item.reading_minscore === null &&
                  item.reading_maxscore === null
                    ? '-'
                    : item.reading_minscore === item.reading_maxscore
                    ? item.reading_minscore
                    : `${item.reading_minscore}-${item.reading_maxscore}`}
                </td>
                <td className="text-center">
                  {item.science_minscore === null &&
                  item.science_maxscore === null
                    ? '-'
                    : item.science_minscore === item.science_maxscore
                    ? item.science_minscore
                    : `${item.science_minscore}-${item.science_maxscore}`}
                </td>
                <td className="text-center">
                  <strong>{item.scale_score}</strong>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ConfirmModal
        open={importModalOpen}
        title="Import Questions"
        message={importModalMessage}
        onCancel={() => setImportModalOpen(false)}
        onConfirm={() => setImportModalOpen(false)}
      />
    </div>
  )
}
export default ActImport
